import * as React from "react";
import { useRifm } from "rifm";
import { formatPhoneNumber } from "@nju/utils";
import { Input, InputProps, InputStyleProps } from "../Input";

const accept = /\d{0,9}/g;

interface IProps extends InputStyleProps {
  onValueChange?: (value: string) => void;
  defaultValue?: string;
  suffix?: InputProps["suffix"];
  isDisabled?: boolean;
  label?: string;
}

const numberFormat = (value: string) => {
  return formatPhoneNumber(value, accept, " ");
};

export function MobilePhoneNumberField({
  state,
  onValueChange,
  suffix,
  label = "numer telefonu",
  defaultValue = "",
  isDisabled,
}: IProps) {
  const [value, setValue] = React.useState(defaultValue);

  const rifm = useRifm({
    accept,
    value,
    onChange: setValue,
    format: numberFormat,
  });

  React.useEffect(() => {
    if (onValueChange) {
      onValueChange(value);
    }
  }, [value, onValueChange]);

  return (
    <Input
      isDisabled={isDisabled}
      label={label}
      name="phone"
      onChange={rifm.onChange}
      prefix="+48"
      state={state}
      suffix={suffix}
      value={rifm.value}
    />
  );
}
